module.exports = __webpack_public_path__ + "static/media/13.ba41a6ca.jpg";